import { Injectable } from '@angular/core';
import { PortalCaseHistoryDto } from '@app/core/domain/case/models/portalCaseHistoryDto';

@Injectable({
    providedIn: 'root',
})
export class DashboardDataStoreService {
    public caseData: PortalCaseHistoryDto;
    public comingBack: boolean;
    public comingFromDashboard: boolean;
    constructor() {
        this.caseData = null;
        this.comingBack = false;
        this.comingFromDashboard = false;
    }

    public resetData(): void {
        this.caseData = null;
        this.comingBack = false;
        this.comingFromDashboard = false;
    }

    public resetPreviousState(): void {
        this.comingBack = false;
    }
}
